import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { api, apiErr } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setError("Passwords do not match."); return; }
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 2000);
    } catch (e) { setError(apiErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#06080c] text-white p-6" data-testid="reset-password-page">
      <div className="w-full max-w-sm rounded-2xl bg-[#0f131b] border border-white/10 p-8 shadow-2xl">
        {done ? (
          <div className="text-center" data-testid="reset-done">
            <CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto mb-3" />
            <h1 className="text-xl font-bold mb-2">Password updated</h1>
            <p className="text-white/60 text-sm">Redirecting you to sign in…</p>
          </div>
        ) : !token ? (
          <div className="text-center text-white/70" data-testid="reset-notoken">This reset link is invalid. Please request a new one.</div>
        ) : (
          <form onSubmit={submit}>
            <h1 className="text-xl font-bold mb-1">Set a new password</h1>
            <p className="text-white/50 text-sm mb-5">Choose a strong password you haven't used before.</p>
            <input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" autoFocus
              className="w-full h-11 rounded-lg bg-white/5 border border-white/10 px-3.5 text-sm outline-none focus:border-[#38bdf8]/60 mb-3" />
            <input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm new password"
              className="w-full h-11 rounded-lg bg-white/5 border border-white/10 px-3.5 text-sm outline-none focus:border-[#38bdf8]/60 mb-3" />
            {error && <div className="text-sm text-red-300 mb-3" data-testid="reset-error">{error}</div>}
            <button data-testid="reset-submit" disabled={busy || pw.length < 6} className="w-full h-11 rounded-lg bg-[#38bdf8] text-[#06121b] font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
